import React, { useState } from 'react'
import { Grid, Typography } from '@mui/material'
import { StatusChipV4 } from '@labrav/react-components'
import { ShortenedNameV2 } from '@labrav/common'
import { snakeCase } from 'lodash'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faChevronDown,
  faChevronRight,
} from '@fortawesome/pro-regular-svg-icons'

import {
  DisbursementStatus,
  ReportsRow,
} from '../../../modules/revenueInsightsV2/types'
import { useStyles } from './RevenueInsightsCommon.style'
import { getStatusAndLabelForRevenueInsights } from '../../../common/utils/getStatusAndLabelForRevenueInsights'
import { getCollectionStatusAndLabel } from '../../../common/utils/getCollectionStatusAndLabel'
import { formatToDecimalPlaces } from '../../../common/utils/revenueHelpers'
import {
  keysWithCostToDecimnal,
  keysWithPercentageToDisplay,
} from '../../../common/utils/revenueConstants'

export interface RevenueInsightsCommonComponentProps {
  rowHeader: string
  reportRow: ReportsRow
  colsToRender: Record<string, string>
  headerIcon: JSX.Element
  currencySymbol?: string
}

export const RevenueInsightsDetailsComponent: React.FC<
  RevenueInsightsCommonComponentProps
> = ({ rowHeader, reportRow, colsToRender, headerIcon }) => {
  const { classes } = useStyles()
  const [isExpanded, setIsExpanded] = useState(false)

  const statusLabel = getStatusAndLabelForRevenueInsights(
    reportRow?.disbursementStatus as DisbursementStatus
  )
  const collectionStatusLabel = getCollectionStatusAndLabel(reportRow)

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded)
  }

  return (
    <>
      <div
        className={classes.rowHeader}
        onClick={toggleExpanded}
        style={{ cursor: 'pointer' }}
      >
        {headerIcon}
        <div>{rowHeader}</div>
        <FontAwesomeIcon
          icon={isExpanded ? faChevronDown : faChevronRight}
          className={classes.chevronIcon}
        />
      </div>

      {isExpanded && (
        <Grid container data-testid={snakeCase(rowHeader)}>
          {Object.keys(colsToRender).map(k => {
            const key = k || ''
            const value = reportRow[colsToRender[key] as keyof ReportsRow]

            return (
              <Grid className={classes.gridContainer} size={6} key={key}>
                <Typography className={classes.rowTitle}> {key} </Typography>
                <Typography className={classes.rowValue}>
                  {key === 'Disbursement status' ? (
                    <StatusChipV4 {...statusLabel} />
                  ) : key === 'Collection status' ? (
                    <StatusChipV4 {...collectionStatusLabel} />
                  ) : keysWithCostToDecimnal.includes(colsToRender[key]) ? (
                    `$${formatToDecimalPlaces(value)}`
                  ) : keysWithPercentageToDisplay.includes(
                      colsToRender[key]
                    ) ? (
                    `${value}%`
                  ) : (
                    <ShortenedNameV2 name={value || '-'} length={20} />
                  )}
                </Typography>
              </Grid>
            )
          })}
        </Grid>
      )}
    </>
  )
}
